const isCookieAvailable = ( name ) =>
  document.cookie.split( '; ' ).some( cookie => cookie.startsWith( name + '=' ) );
if( isCookieAvailable( 'STYXKEY_responseType' ) ) {
  window.scrollTo( {
    top: 0 ,
    behavior: 'smooth'
  } );
}
